export default "__VITE_ASSET__BBlIqD4d__"